import CurrentUser from 'user/current-user-service.js';
import eCommerceService from 'core-services/ecommerce-origin-service.js';
import ExceptionService from 'core-services/exceptions/exception-service.js';
import WindowLocationService from 'common/window-location.service.js';
import FreeTrialExperiment from 'experiments/free-trial-experiment.js';
import FreeTrialBannerReferral from 'free-trial/free-trial-banner/free-trial-banner-referral.js';
import FreeTrialBannerBasic from 'free-trial/free-trial-banner/free-trial-banner-basic.js';
import {getPricing} from 'pricing/pricing-service';
import {
    findFreeTrialPlan,
    buildCheckoutRequiredParams,
    FREE_TRIAL_TYPES,
    getFreeTrialType,
    getFreeTrialPricingCohort,
} from '@busuu/pricing';

// Private vars
const FILENAME = 'free-trial-banner-controller.js';
let pricingCohort = null;
let currentUser = null;
let trialType = null;
let freeTrialPlan = null;

const onError = (error) => {
    ExceptionService.handle('warning', {
        filename: FILENAME,
        message: 'Tiered plans could not be loaded for free claim trial banner',
        data: error,
    });
};

const getTrialType = (user) => {
    const type = getFreeTrialType(user);

    if (!type) {
        throw {
            reason: 'UNIDENTIFIED_TRIAL_TYPE',
        };
    }

    return type;
};

const onTrialSelection = (ecommerceOrigin, href) => {
    const params = buildCheckoutRequiredParams(freeTrialPlan.id, pricingCohort);
    eCommerceService.store(ecommerceOrigin);
    WindowLocationService.redirect(`${href}?${params}`);
};

const loadReferralBanner = (freeTrialDays) => {
    new FreeTrialBannerReferral(freeTrialDays, {
        onClickCTA: onTrialSelection.bind(this, 'CLAIM_REFERRAL_FT_PAYWALL_BANNER'),
    });
};

const loadBasicBanner = (freeTrialDays) => {
    new FreeTrialBannerBasic(freeTrialDays, {
        onClickCTA: onTrialSelection.bind(this, 'CLAIM_BASIC_FT_PAYWALL_BANNER'),
    });
};

const loadFreeTrialBanner = (type) => {
    const {free_trial_duration_days: freeTrialDays} = freeTrialPlan;
    if (type === FREE_TRIAL_TYPES.BASIC && FreeTrialExperiment.isInOneDayFTVariant()) {
        return loadBasicBanner(freeTrialDays);
    }

    if (type === FREE_TRIAL_TYPES.REFERRAL) {
        return loadReferralBanner(freeTrialDays);
    }
};

const init = async () => {
    try {
        // Fetch the user and the pricing cohort (user is required here to proceed, otherwise .catch())
        currentUser = await CurrentUser.get();
        trialType = getTrialType(currentUser);

        // Get cohort and products
        pricingCohort = getFreeTrialPricingCohort(trialType);
        const products = await getPricing(pricingCohort);

        // Get Free trial plan
        freeTrialPlan = findFreeTrialPlan(products);
        if (!freeTrialPlan || !freeTrialPlan.free_trial_duration) {
            throw {reason: 'NO_FREE_TRIAL_PLAN'};
        }

        // Finally load the correct banner
        loadFreeTrialBanner(trialType);
    } catch (e) {
        onError(e);
    }
};

const FreeTrialBanner = {
    init,
};

export default FreeTrialBanner;
